import Answer from './answer'
import Question from './question'
import Assessment from './assessment'
import ExamEvaluation from './exam_evaluation'
import Skill from './skill'

export default class UserExam {
  readonly id: number
  readonly userId: number
  readonly corrects: number
  readonly score: number
  readonly finishedAt: Date | undefined
  readonly createdAt: Date
  readonly updatedAt: String
  readonly cheating: String
  readonly skillScore: number
  readonly startedAt: Date | undefined
  readonly testMode: boolean
  readonly passed: boolean
  readonly enquete: boolean
  readonly average: number
  readonly position: number
  readonly canAnswer: boolean
  readonly marked: boolean

  answers: Answer[] = []
  questions: Question[] = []
  assessment: Assessment[] = []

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.userId = data.userId
    this.corrects = data.corrects
    this.score = data.score
    this.createdAt = new Date(data.createdAt)
    this.updatedAt = data.updatedAt
    this.cheating = data.cheating
    this.skillScore = data.skillScore
    this.testMode = data.testMode
    this.passed = data.passed
    this.enquete = data.enquete
    this.average = data.average
    this.position = data.position
    this.canAnswer = data.canAnswer
    this.marked = data.marked

    if (data.finishedAt) {
      this.finishedAt = new Date(data.finishedAt)
    }
    if (data.startedAt) {
      this.startedAt = new Date(data.startedAt)
    }
    if (data.as) {
      this.answers = data.as.map(element => new Answer(element))
    }
    if (data.qs) {
      this.questions = data.qs.map(element => new Question(element))
    }
    if (data.assessments) {
      this.assessment = data.assessments.map(element => new Assessment(element))
    }
  }

  public get isWaitingScoreCheck(): boolean {
    return this.marked === false
  }

  public getAssessmentByQuestion(questionId: number): Assessment[] {
    return this.assessment.filter(item => item.qId === questionId)
  }

  public getAnswersByQuestion(questionId: number): Answer | undefined {
    return this.answers.find(item => item.qId === questionId)
  }
}

export class UserExamDetail extends UserExam {
  readonly userExamsCount: number
  readonly examId: number
  readonly examName: string
  readonly useExamEvaluation: boolean
  readonly examEvaluations: ExamEvaluation[] = []
  readonly examSkills: Skill[]
  readonly examHideResult: boolean = false
  constructor(data: { [key: string]: any }) {
    super(data)
    this.userExamsCount = data.userExamsCount
    this.useExamEvaluation = data.useExamEvaluation
    this.examId = data.examId
    this.examName = data.examName
    this.examHideResult = data.examHideResult ?? false
    if (data.examEvaluations) {
      this.examEvaluations = data.examEvaluations.map(item => new ExamEvaluation(item))
    }
    if (data.examSkills) {
      this.examSkills = data.examSkills.map(element => new Skill(element))
    }
  }
}
